<template>
  <div class="problem">
    <Header :title="title" :right-content="rightContent" />
    <div id="content">
      <div class="layout">
        <div class="dv_list">
          <ul>
            <li v-for="(item,index) in problemList" :key="index">
              <div class="item" @click="showSub(index)">
                <span>{{ item.title }}</span>
                <!-- Check if the array includes the current index -->
                <img src="@/assets/images/template/user_arrow.png" :class="{'rotate-down': activeIndices.includes(index)}">
              </div>
              
              <!-- Check if the array includes the current index -->
              <div class="itemCon" :class="{'open': activeIndices.includes(index)}">
                <div v-html="item.content"></div>
              </div>
            </li>
          </ul>
        </div>
        <Chat />
      </div>
    </div>
  </div>
</template>

<script>
require('@/assets/css/problem.css')
import Header from '@/view/module/Header.vue'
import Chat from '@/view/module/Chat.vue'

export default {
  name: 'Problem',
  components: { Header, Chat },
  data() {
    return {
      title: '常见问题',
      rightContent: 'isNo',
      // 1. Replaced activeSubIndex with an array to hold multiple open indices
      activeIndices: [],
      problemList: [
        {
          title: '银行预留手机是什么？',
          content: '银行预留手机是指您在银行预留的手机号码，如果提示，“手机与银行预留手机不一致”等，请您联系银行修改预留手机'
        },
        {
          title: '是否可以修改持卡人信息？',
          content: '为了保障账户和资金的安全，只能绑定与账户身份信息一致的银行卡'
        },
        {
          title: '怎么删除绑定的银行卡？',
          content: '取款银行卡可以通过【银行卡管理】直接解绑，存款银行卡请在【支付设置】中进行删除。'
        },
        {
          title: '银行卡绑定达到上限怎么办?',
          content: `<ul>
                      <li><strong>存款绑定：</strong>可支持绑定 <strong>5张</strong> 银行卡。用户可在“支付设置”中自行删除已绑定的存款卡。</li>
                      <li><strong>取款绑定：</strong>可支持绑定 <strong>3张</strong> 银行卡。用户现可通过“银行卡管理”页面，点击对应银行卡右上角的菜单按钮，选择“解绑”操作自行完成，无需联系客服。</li>
                      <li><strong>重新绑定：</strong>解绑后，用户可按正常流程重新绑定新的取款卡。</li>
                    </ul>`
        }
      ]
    }
  },
  mounted() {
    this.removeFixed()
    this.$bus.$emit('loading', true)
    window.scrollTo(0, 0)
  },
  activated() {
    this.removeFixed()
    this.$bus.$emit('loading', true)
    window.scrollTo(0, 0)
  },
  methods: {
    removeFixed() {
      const mainH = document.getElementById('main')
      if (mainH) mainH.classList.remove('mainFixed')
    },
    showSub(index) {
      // 2. Check if the index is already in the array
      const position = this.activeIndices.indexOf(index)
      
      if (position !== -1) {
        // If it's already open, remove it from the array to close it
        this.activeIndices.splice(position, 1)
      } else {
        // If it's closed, add it to the array to open it
        this.activeIndices.push(index)
      }
    }
  }
}
</script>